// src/pages/ResetRequest.jsx
import { useState } from 'react'
import { supabase } from '../lib/supabaseClient'

export default function ResetRequest() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')

  async function onSubmit(e) {
    e.preventDefault()
    setError('')
    if (!email) return setError('이메일을 입력해주세요.')
    try {
      const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      })
      if (err) throw err
      setSent(true)
    } catch (e) {
      setError(e.message || '재설정 메일 전송 실패')
    }
  }

  if (sent) {
    return (
      <div className="max-w-md mx-auto">
        <h1 className="text-xl font-bold mb-2">재설정 메일 전송 완료</h1>
        <div className="rounded-2xl border bg-white p-4 text-sm">
          <p>입력하신 주소로 비밀번호 재설정 링크를 보냈습니다. 메일함을 확인해 주세요.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-4">비밀번호 재설정</h1>
      <div className="rounded-2xl border bg-white p-4">
        <form onSubmit={onSubmit} className="grid gap-3">
          <input
            className="input"
            type="email"
            placeholder="가입 이메일"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          {error && <div className="text-sm text-rose-600">{error}</div>}
          <button className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700" type="submit">
            재설정 링크 보내기
          </button>
        </form>
      </div>
    </div>
  )
}
